// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const ORGANIZATION_ACTIONS_KEY = {
  SET_CURRENT_ORGANIZATION: 'SET_CURRENT_ORGANIZATION',
  GET_ORGANIZATION_BY_ID: 'GET_ORGANIZATION_BY_ID',
  GET_ALL_ORGANIZATIONS: 'GET_ALL_ORGANIZATIONS',
};
